import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NewEntry from './NewEntry';
import { newentryActions } from '../../../store/actions/dashboard/newentry';

const mapStateToProps = (state) => {
	const { login, newentry } = state;
	const { isLogin, loginUser } = login;
	const { newEntryData, visiterData, employeeData, isLoaded, isUpdated, isDeleted } = newentry;

	return {
		isLogin,
		loginUser,
		newEntryData,
		visiterData,
		employeeData,
		isLoaded,
		isUpdated,
		isDeleted,
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(newentryActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewEntry);
